import React, { useEffect } from 'react'
import { Accordion, Modal } from "react-bootstrap";
import './You_Are_Almost_There_Modal.css'
import { useNavigate } from 'react-router-dom';
import Common_Enquiry_Form from '../../Common_Enquiry_Form/Common_Enquiry_Form';

const You_Are_Almost_There_Modal = (props) => {

    const navigate = useNavigate()

    // useEffect(() => {

    //     const timer = setTimeout(() => {

    //         console.log("navigate", props?.navigate)

    //         if (props?.navigate) {
    //             navigate(props.navigate);
    //         } else if (props?.onHide) {
    //             props.onHide();
    //         }
    //     }, 3000);

    //     return () => clearTimeout(timer);
    // }, [navigate, props.navigate, props.onHide]);

    return (
        <section>

            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="You_Are_Almost_There_Modal modal-holder"
            >
                <Modal.Header closeButton>
                </Modal.Header>

                <Modal.Body className='p-0'>
                    <div className='main_container'>
                        <Common_Enquiry_Form onHide={props.onHide}/>

                    </div>
                </Modal.Body>
            </Modal>

        </section>
    )
}

export default You_Are_Almost_There_Modal
